import React from 'react';
import {notificationIcons} from "./notificationIcons";
import Avatar from "@mui/material/Avatar";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import {Typography, Chip} from "@mui/material";
import ListItemButton from "@mui/material/ListItemButton";
import Span from "@jumbo/shared/Span";
import moment from "moment";

const NotificationLog = ({item}) => {
    return (
        <ListItemButton 
            component={"li"} 
            alignItems={"flex-start"}
            sx={{ cursor: 'default', '&:hover': { cursor: 'default' } }}
            disableRipple
        >
            <ListItemAvatar>
                <Avatar sx={{ bgcolor: item.status === "sucesso" ? "success.main" : "error.main" }}>
                    {item.number?.charAt(0) || "R"}
                </Avatar>
            </ListItemAvatar>
            <ListItemText>
                <Typography variant="body1" component="span">
                    {item.message}
                </Typography>
                <Typography component="span" sx={{
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '90%',
                    mt: .5,
                    gap: 1,
                }}>
                    {notificationIcons.LOG}
                    <Chip 
                        label={String(item.status).toUpperCase()} 
                        size="small"
                        color={item.status === "sucesso" ? "success" : "error"}
                        sx={{ height: 18, fontSize: '0.65rem' }}
                    />
                    <Span sx={{color: 'text.secondary', ml: 1}}>
                        {moment(item.date || item.createdAt).format("HH:mm")}
                    </Span>
                </Typography>
            </ListItemText>
        </ListItemButton>
    );
};

export default NotificationLog;
